/* *
 * By The Christian Post.
 * The earth shall be full of the knowledge of the Lord as the waters cover the sea! Isaiah 11:9
 * */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/css/search.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import TagManager from 'react-gtm-module'
import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";
import en from './lang/en';
import ko from './lang/ko';
import pt from './lang/pt';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: { translation: en },
      ko: { translation: ko },
      pt: { translation: pt },
    },
    lng: process.env.REACT_APP_DEFAULT_LOCALE, // if you're using a language detector, do not define the lng option
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    }
  });

const tagManagerArgs = {
  gtmId: 'GTM-MWCM5QQ'
};
TagManager.initialize(tagManagerArgs)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


/* *
 * STANDARD FOOTER:
 * The earth shall be full of the knowledge of the Lord as the waters cover the sea! Isaiah 11:9
 * */
